import { render, staticRenderFns } from "./stepsZero.vue?vue&type=template&id=27046020&scoped=true"
import script from "./stepsZero.vue?vue&type=script&lang=js"
export * from "./stepsZero.vue?vue&type=script&lang=js"
import style0 from "./stepsZero.vue?vue&type=style&index=0&id=27046020&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27046020",
  null
  
)

export default component.exports